import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styles from './TitleBox.module.css'
import { Button, Divider, Flex, message, Tooltip } from 'antd'
import classNames from 'classnames'
import userIcon from './userIcon.svg'
import shareImgIcon from './shareImg.svg'
export default function TitleBox(props) {
  //   const count = useSelector(selectCount);
  const dispatch = useDispatch()
  const [messageApi, contextHolder] = message.useMessage()

  // const incrementValue = Number(incrementAmount) || 0;

  useEffect(() => {
    // 在这里执行你的组件挂载后的逻辑
    // 这里可以返回一个清理函数，它会在组件卸载前执行
    return () => {
      // console.log('组件即将卸载');
    }
  }, []) // 空数组意味着这个 effect 只会在组件挂载时执行一次
  return (
    <div
    className={styles.background}
    >
      🔥教学材料资源库
      <div className={styles.subtitle}>
        精选优质教学资源，助力高效课堂教学
      </div>
    </div>
  )
}
